import React from "react";
import "../../styles/categories.css";

const Categories = () => {
 const featuresData = [
    {
      id: 1,
      title: "Step-by-Step Application Support",
      desc: "From eligibility check to registration.",
      img: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 2,
      title: "Training + Study Material",
      desc: "Latest international syllabus coverage.",
      img: "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 3,
      title: "Mock Tests & Question Banks",
      desc: "To ensure exam readiness.",
      img: "https://images.unsplash.com/photo-1606326608606-aa0b62935f2b?auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 4,
      title: "Visa & Placement Assistance",
      desc: "Guidance for those looking to work abroad.",
      img: "https://images.unsplash.com/photo-1569974498991-d3c12a504f95?auto=format&fit=crop&w=600&q=80"
    }
  ];

  return (
    <section className="categories-section container">
      {/* Section Title */}
      <h2 className="section-title text-center">
        Why Choose Madhi Academy - Global?
      </h2>

      <div className="categories-wrapper">
        {featuresData.map((item) => (
          <div key={item.id} className="category-item">
            {/* Image Container */}
            <div className="img-box">
              <img src={item.img} alt={item.title} className="category-img" />
            </div>
            
            {/* Text Content */}
            <h5 className="category-title">{item.title}</h5>
            <p className="category-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Categories;